export const SvgImageRegex = new RegExp(/\.svg|image\/svg/);
